import "./slider.scss";
import Swiper from "swiper/bundle";

class Slider {
  constructor(el, slides, sp, loop, autoslide) {
    this.el = el;
    this.slides = slides || 3;
    this.space = sp || 20;
    this.loop = loop === true; // Default to false
    this.autoslide = autoslide === true; // Default to false
    this.slider = null;
    this.create();
  }

  create() {
    const next = this.el.querySelector(".next");
    const prev = this.el.querySelector(".prev");
    const paginationEl = this.el.querySelector(".swiper-pagination");

    const swiperConfig = {
      slidesPerView: 1,
      spaceBetween: this.space,
      speed: 400,
      grabCursor: true,
      loop: true,

      // loop: this.loop,
      centeredSlides: this.loop,
      initialSlide: this.loop ? 2 : 0,
      
      breakpoints: {
        1024: {
          slidesPerView: this.slides,
        },
        768: {
          slidesPerView: this.slides - 1,
        },
      },

      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 2,
      },

      navigation: {
        nextEl: next,
        prevEl: prev,
      },

      pagination: {
        el: paginationEl,
        type: "bullets",
        clickable: false,
      },
    };

    // Add autoplay if autoslide is enabled
    if (this.autoslide) {
      swiperConfig.autoplay = {
        delay: 4000,
        disableOnInteraction: true,
      };
    }

    this.slider = new Swiper(this.el, swiperConfig);
  }

  destroy() {
    if (this.slider) {
      this.slider.destroy();
      this.slider = null;
    }
  }
}

var swiperSliders = [];

function initSlider() {
  const sliders = document.querySelectorAll(".slider");
  sliders.forEach((slider) => {
    const sliderSwiper = slider.querySelector(".swiper");
    const slides = slider.getAttribute("data-slides");
    const space = slider.getAttribute("data-space");
    const loop = slider.getAttribute("data-loop") === "true";
    const autoslide = slider.getAttribute("data-autoslide") === "true";
    const slsw = new Slider(sliderSwiper, slides, space, loop, autoslide);
    swiperSliders.push(slsw);
  });
}

function destroySlider() {
  swiperSliders.forEach((slider) => {
    slider?.destroy();
  });
  swiperSliders.length = 0;
}

export { Slider, initSlider, destroySlider };
